import { useMemo } from 'react';

import { useCageController_getHealthOverview } from '@/services/hooks';
import type { CageHealthOverviewResponseDto } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapCageHealthOverviewToDomain } from './mappers';
import type { UseGetCageHealthOverviewResult } from './types';

/**
 * For the cage, or for the fish group named by `fishGroupId` (the page's `fg`). Without one the
 * request carries no query params.
 */
export function useGetCageHealthOverview(
    cageId: number,
    params: { fishGroupId?: number } = {},
    options?: DomainQueryOptions<CageHealthOverviewResponseDto>
): UseGetCageHealthOverviewResult {
    const query = useCageController_getHealthOverview(
        cageId,
        params.fishGroupId != null ? { fishGroupId: params.fishGroupId } : undefined,
        options
    );

    const cageHealthOverview = useMemo(() => {
        if (!query.data?.data) {
            return null;
        }
        return mapCageHealthOverviewToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: cageHealthOverview,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
}
